export const SHOW_MULTI_PDP_VISITS = 'SHOW_MULTI_PDP_VISITS';
export const SHOW_AUCTION_SAVE_PROMPT = 'SHOW_AUCTION_SAVE_PROMPT';

export const PRIORITIES = {
    MULTI_PDP_VISITS: 345,
    SHOW_AUCTION_SAVE_PROMPT: 360,
};

export const NOTIFICATION_KEYS = {
    MULTI_PDP_VISITS: 'multiPdpVisits',
    AUCTION_SAVE_PDP_PROMPT: 'auctionPdpPrompt',
};
